<script>

    import { navigate } from "svelte-navigator";
    import Radio from './Radio.svelte';
    import Checkboxes from './Checkboxes.svelte';
    import Range from './Range.svelte';
    import { filterStore, rangesStore } from '../stores.js';

    export let filters = [];

    $: all = $filterStore.length === 0 ? 'All' : '';

    function goHome(){
        navigate("/");
    }

    function reset(){
        goHome();
        filterStore.set([]);
    }

</script>

<nav class="text-l">
    
    <div>
        <Radio on:change={reset} bind:group={all} title="Show all posts" name="all" value='All'>All</Radio>
    </div>
    
    <Checkboxes on:change={goHome} values={filters} bind:group={$filterStore} />
    
</nav>

<div class="text-l">
    <Range on:change={goHome} bind:value={$rangesStore.range1} options={['All', 'Solo', 'Duo', 'Trio', 'Quartett', 'Quintett', 'Sextett', 'Molto', 'Molto', 'Molto']} />
    <Range on:change={goHome} bind:value={$rangesStore.range2} options={['All', 'Acoustic', 'Electronic']} />
    <Range on:change={goHome} bind:value={$rangesStore.range3} options={['All', 'Notiert', 'Improvisiert']} />
</div>

<style>

    @media (max-width: 720px){
        nav {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }
    
    div {
        margin-bottom: 0.1em;
    }

</style>